// extracted by mini-css-extract-plugin
export var container = "PostListContainer-module--container--2Cmm_";